import { mainRoute } from '@pages/main-page'
import { createRoute } from '@tanstack/react-router'
import { DesktopOnlyLayout } from './desktop-only-layout'

export const desktopOnlyLayout = createRoute({
  getParentRoute: () => mainRoute,
  id: '_desktop_layout',
  component: DesktopOnlyLayout
})
